module.exports = __webpack_public_path__ + "static/media/hr-1541526484189-2048x2048.2ed37836.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backgrounds/community-gardens/hr-1541526484189-2048x2048.png
// module id = 842
// module chunks = 13